import DayTemplateIndex from "@/components/DayTemplates/Index.vue"

import MasterDayTemplates from "@/components/DayTemplates/MasterDayTemplates.vue"
import DayTemplateHeader from "@/components/DayTemplates/DayTemplateHeader.vue"
import DayTemplateSectionHeader from "@/components/DayTemplates/DayTemplateSectionHeader.vue"
import DayTemplateSectionActions from "@/components/DayTemplates/DayTemplateSectionActions.vue"
import DayTemplateActions from "@/components/DayTemplates/DayTemplateActions.vue"
import DayTemplateMenu from "@/components/DayTemplates/DayTemplateMenu.vue"
import DayTemplateSourcePanel from "@/components/DayTemplates/DayTemplateSourcePanel.vue"
import DayTemplateDetails from "@/components/DayTemplates/DayTemplateDetails.vue"
import DayTemplateAdBreaks from "@/components/DayTemplates/DayTemplateAdBreaks.vue"
import DetailsMaster from "@/components/DayTemplates/Details_Master.vue";
import DetailsConstraints from  "@/components/DayTemplates/DayTemplateConstraints.vue";
import MenuList from "@/components/DayTemplates/MenuList";

export default {
    path: '/:stationUid/day-templates',
    components: {
        default: MasterDayTemplates,
        menu: MenuList
    }, children: [
        {
            name: "DayTemplatesHome", path: "/",
            components: {
                default: DayTemplateIndex,
                subPageHeader: DayTemplateSectionHeader,
                pageActions: DayTemplateSectionActions
            }
        },
        {
            path: ':dayTemplateUid',
            redirect: ':dayTemplateUid/details',
            components: {
                default: DetailsMaster,
                subPageHeader: DayTemplateHeader,
                pageActions: DayTemplateActions,
                rightPanel: DayTemplateSourcePanel,
                pageSubMenu: DayTemplateMenu,
            },
            children:[
                {
                    name: "DayTemplateDetails",
                    path: 'details',
                    components: {
                        default: DayTemplateDetails,
                        rightPanel: DayTemplateSourcePanel,
                    }
                },
                {
                    name: "DayTemplateAdBreaks",
                    path: 'adbreaks',
                    components: {
                        default: DayTemplateAdBreaks,
                        subPageHeader: DayTemplateHeader,
                        rightPanel: null,
                    }
                },
                {
                    name:'DayTemplateConstraints',
                    path: 'constraints',
                    component: DetailsConstraints,
                }
            ]
        }
    ]
};